import { CultureInfo } from '../culture-info.model';
import { CultureInfoRu } from './ru';

/**
 * @ignore
 */
export const CultureInfoRuUA: CultureInfo = {
  name: 'ru-UA',
  displayName: 'русский (Украина)',
  iso3LanguageCode: 'rus',
  iso2LanguageCode: 'ru',
  ietfLanguageTag: 'ru-UA',
  parent: CultureInfoRu
};
